import { PageLoading } from '@ant-design/pro-layout';
import { NavContext } from '@ionic/react';
import { Suspense, useContext, useEffect, useState } from 'react';
import { renderRoutes } from 'react-router-config';
import ExceptionManager from '../../components/common/ExceptionManager';
import { ContextApp } from '../../contexts/ContextApp';
import { useCurrentRoute } from '../../hooks';
import './index.less';
import { Col, Row } from 'antd';
import GraphqlService from '../../services/graphql/GraphqlService';
import { IAppSetting } from '../../interfaces';
import { EnumsValues } from '../../enums/EnumsValues';
import image from '../../assets/FlowDesk-login.png';
interface ILoginFrame {
  type: 'img' | 'video';
  content: string;
  cta_text: string;
  cta_url: string;
  cta_redirect: string;
}

const PublicLayout = ({ route }: any) => {
  const { Query, customRequest } = GraphqlService();
  const { user, t } = useContext(ContextApp);
  const { navigate } = useContext(NavContext);
  const { leafRoute } = useCurrentRoute();
  const [contactLink, setContactLink] = useState('');

  const [loginFrame, setLoginFrame] = useState<ILoginFrame | null>(null);

  const getContactLink = async () => {
    const data: IAppSetting = await customRequest({
      query: Query.getAppSettingByKey,
      variables: {
        input: { key: EnumsValues.SettingNames.ContactLinkOnHelp },
      },
    });
    setContactLink(data.setting_value);
  };

  useEffect(() => {
    getContactLink();
  }, []);

  useEffect(() => {
    if (user && leafRoute && leafRoute?.path !== '/') navigate('/');
  }, [user, leafRoute]);

  useEffect(() => {
    const fetchSetting = async () => {
      try {
        const response: IAppSetting = await customRequest({
          query: Query.getAppSettingByKey,
          variables: { input: { key: 'LOGIN_FRAME' } },
        });

        if (
          response &&
          response.setting_name === 'LOGIN_FRAME' &&
          response.setting_value
        ) {
          let value =
            typeof response.setting_value === 'string'
              ? JSON.parse(response.setting_value)
              : response.setting_value;

          if (
            !value ||
            !value.type ||
            value.type === null ||
            value.content === null
          ) {
            value = {
              type: 'img',
              cta_text: 'FlowDesk™: armá tu proceso de negocio',
              cta_url: 'Sumar esta función',
            };
          }

          setLoginFrame(value);
        } else {
          console.error('Error al obtener la setting: LOGIN_FRAME');
        }
      } catch (error) {
        console.error('Error en GraphQL:', error);
      }
    };

    fetchSetting();
  }, []);

  return (
    <div className="PublicLayout">
      <Row className="index-row">
        <Col md={12} className="leftSide">
          {/* Aca se puede crear elementos para todas las paginas*/}
          <div className="PublicLayoutContentColumn">
            <div className="PublicLayoutHeader">
              <img
                className="PublicLayoutTitle"
                src="assets/icon/logo_braulio.png"
                alt="Braulio"
              />
            </div>
            <p className="braulio-settings-info">{t('loginPage.info')}</p>
          </div>
          <div className="BraulioSettingsFeaturesContent">
            <div className="BraulioSettingsFeaturesContentHeader">
              <p className="braulio-settings-new-features">
                {t('loginPage.newFeatures')}
              </p>
            </div>
            <div
              className={`BraulioSettingsFeaturesContentMultimedia ${
                loginFrame?.type === 'video' ? 'video-mode' : ''
              }`}
            >
              <div
                className={`BraulioSettingsFeaturesContentMultimediaItem ${
                  loginFrame?.type === 'video' ? 'video-mode' : 'image-mode'
                }`}
              >
                <div className="BraulioSettingsFeaturesContentMultimediaItemImage">
                  {loginFrame?.type === 'img' && (
                    <img
                      src={loginFrame.content ? loginFrame.content : image}
                      alt=""
                    />
                  )}
                  {loginFrame?.type === 'video' &&
                    (() => {
                      let embedUrl: string | null = null;

                      if (loginFrame.content.includes('youtu.be/')) {
                        const videoId =
                          loginFrame.content.split('youtu.be/')[1];
                        embedUrl = `https://www.youtube.com/embed/${videoId}`;
                      } else if (loginFrame.content.includes('watch?v=')) {
                        const videoId = loginFrame.content.split('watch?v=')[1];
                        embedUrl = `https://www.youtube.com/embed/${videoId}`;
                      }

                      //si hay un embed de YouTube, usar iframe
                      if (embedUrl) {
                        return (
                          <iframe
                            width="100%"
                            height="315"
                            src={`${embedUrl}?autoplay=1&mute=1&loop=1&playlist=${
                              embedUrl.split('/embed/')[1]
                            }`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            style={{ borderRadius: '12px' }}
                          ></iframe>
                        );
                      }

                      // si no es de YouTube, reproducirlo como archivo directo (.mp4, etc.)
                      return (
                        <video
                          src={loginFrame.content}
                          controls
                          playsInline
                          autoPlay={true}
                          preload="metadata"
                          style={{
                            maxWidth: '100%',
                            borderRadius: '12px',
                            backgroundColor: 'black',
                          }}
                        >
                          Tu navegador no soporta el video.
                        </video>
                      );
                    })()}
                </div>
                <div className="BraulioSettingsFeaturesContentMultimediaItemText">
                  {loginFrame?.type === 'img' && <p>{loginFrame?.cta_text}</p>}
                  {loginFrame?.cta_url && (
                    <div className="BraulioSettingsFeaturesContentMultimediaItemTextButton">
                      <a
                        href={loginFrame?.cta_redirect || contactLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <p>{loginFrame?.cta_url}</p>
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col md={12} className="rightSide">
          {/* child routes won't render without this */}
          <div className="PublicLayoutContent">
            <Suspense fallback={<PageLoading />}>
              <ExceptionManager>{renderRoutes(route.routes)}</ExceptionManager>{' '}
            </Suspense>
          </div>
          <div className="PublicLayoutFooter"></div>
        </Col>
      </Row>
    </div>
  );
};

export default PublicLayout;
